import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';

import { filter, Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseConfig } from '@rx-applications/clientsite/shared/config/utils';
import { HttpService, ignoreInterceptorHeaders } from '@rx-applications/shared/utils';

@Injectable({
  providedIn: 'root',
})
export class BaseConfigAPI {
  private readonly host = location.origin || `${location.protocol}//${location.hostname}` || location.href;

  readonly httpService = inject(HttpService);
  readonly httpClient = inject(HttpClient);

  getBaseConfig(): Observable<BaseConfig> {
    const params = new HttpParams({
      fromString: `host=${this.host}`,
    });
    const headers = new HttpHeaders({
      [ignoreInterceptorHeaders.ignoreLanguage]: 'true',
      [ignoreInterceptorHeaders.ignoreAuth]: 'true',
      [ignoreInterceptorHeaders.ignoreCid]: 'true',
    });
    return this.httpClient
      .get<BaseConfig>(`${this.httpService.webApiUrl}Config/GetBaseConfig`, {
        params,
        headers,
      })
      .pipe(
        filter((config: BaseConfig) => !!config),
        map((config: BaseConfig) => {
          const value = config.loginCustomHtml || '';
          config.loginCustomHtml = value
            .replace('[strong]', '<strong>')
            .replace('[/strong]', '</strong>')
            .replace('[br/]', '<br />');
          return config;
        })
      );
  }
}
